import type { StorePageConfig } from '@/app/(football)/[team]/store/_context/types';

export const bluewingsConfig: StorePageConfig = {
  titleSection: {
    title: '스토어',
    highlight: '수원삼성 블루카드',
    description: '상품을 만나보세요',
  },
};
